module.exports = requirejs;


//////////////////
// WEBPACK FOOTER
// external "requirejs"
// module id = 22
// module chunks = 0